import React from 'react';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { StyleSheet, Text } from 'react-native';
interface Props {
  heading: string;
  numberOfLines?: number;
}

export const OrderableItemListItemHeading: React.FC<Props> = ({
  heading,
  numberOfLines = 2,
}) => {
  return (
    <Text
      numberOfLines={numberOfLines}
      style={[TYPOGRAPHY.medium, FONTS.primarySemiBold, styles.title]}
    >
      {heading}
    </Text>
  );
};

const styles = StyleSheet.create({
  title: {
    marginVertical: 4,
  },
});
